import React from 'react';
import SleeveDragSource from '../BuildsComponent/SleeveDragSource';

export const Sleeve = (props) => {
    const styleForSleeveIcon = {
        background : props.background
    };
    return (
        <li className="sleeves-item-step-2">
            <label className={"sleeves-item-name-step-2"} htmlFor=""> {props.text}</label>
            <SleeveDragSource
                id = {props.id}
                background= {props.background}
                currentStep = {props.currentStep}
                styleForSleeveIcon = {styleForSleeveIcon}
            />
        </li>
    )
};




// WEBPACK FOOTER //
// ./src/containers/steps/BuildSteps/OptionsArea/Sleeve.js